import { type ResultOf, type VariablesOf, graphql } from "gql.tada";

const AllRestaurantIdsQuery = graphql(`
  query AllRestaurantIds(
    $regionId: Int
    $suburbs: [Int]
    $tags: [Int]
    $sort: RestaurantSortTypes
    $sessions: [SessionTypes]
    $dates: [String]
    $ids: [Int]
    $offersSession: [SessionTypes]
    $offersFirstTableSession: [SessionTypes]
    $offersWalkInSession: [SessionTypes]
    $people: Int
    $status: [RestaurantStatus!]
  ) {
    allRestaurants(
      input: {
        prioritiseByAvailability: { forSession: $sessions, onDate: $dates }
        status: $status
        regionId: $regionId
        suburbs: $suburbs
        tags: $tags
        sort: $sort
        id: $ids
        offersSession: $offersSession
        offersFirstTableSession: $offersFirstTableSession
        offersWalkInSession: $offersWalkInSession
        people: $people
      }
    ) {
      id
      menuTitle
      lat
      lng
      rating
      regionRanking
      __typename
    }
  }
`);

export type QueryVariables = VariablesOf<typeof AllRestaurantIdsQuery>;
export type QueryResult = ResultOf<typeof AllRestaurantIdsQuery>;

export default AllRestaurantIdsQuery;
